module.exports = __webpack_public_path__ + "img/closed-toe-shoes.dba2bdb1.svg";